
export const STATUS_MAP = {
  ALL: 'all',
  COMPLETED: 'paid',
  CANCELED: 'created',
  ON_PROCESS: 'on_process'
};

export const WINDOW_MAP = {
  TODAY: 'today',
  this_week:  'this_week',
  this_month:  'this_month',

};


export const toApiWindow = (k) => WINDOW_MAP[k] ?? 'today';


export function sortParam(field, dir) {
  if (field === 'amount') return dir === 'asc' ? 'amount_asc' : 'amount_desc';
  return dir === 'asc' ? 'date_asc' : 'date_desc'; 
}

const STATUS_UI_MAP = {
  paid: 'COMPLETED',
  created: 'CANCELED',
  canceled: 'CANCELED',
  completed: 'COMPLETED',
  on_process: 'ON_PROCESS'
};

export function toTableRows(apiItems) {

  return (apiItems || []).map(it => ({
    id: it.orderId, // Keep full orderId
    customer: it.customer?.id || 'Unknown',
    date: it.placedAt,
    order_type: (it.orderType || '').toUpperCase(),
    table_number: it.table_number,
    amount: it.amount,
    status: STATUS_UI_MAP[it.status] || (it.status || '').toUpperCase()
  }));
}
